import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function Footer() {
  const footerVariants = {
    hidden: { opacity: 0, y: 12 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <motion.footer
      variants={footerVariants}
      initial="hidden"
      animate="visible"
      style={{
        background: "#050814",
        borderTop: "1px solid rgba(30,42,58,0.9)",
        padding: "1.75rem 1.5rem",
        marginTop: "3rem",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          rowGap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.35rem",
          }}
        >
          <span style={{ fontSize: "0.9rem", color: "#8B9BB4" }}>
            © {new Date().getFullYear()} WaveTech Solutions.
          </span>
          <span style={{ fontSize: "0.9rem", color: "#8B9BB4" }}>
            Infrastructure for real businesses: Shopify apps, web apps, and automations.
          </span>
        </div>

        <nav
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1.25rem",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {[
            { label: "Home", href: "/" },
            { label: "Services", href: "/services" },
            { label: "Apps", href: "/wavenotify" },
            { label: "Blog", href: "/blog" },
            { label: "Process", href: "/process" },
            { label: "Privacy", href: "/privacy" },
            { label: "Contact", href: "/contact" },
          ].map((item) => (
            <Link
              key={item.label}
              to={item.href}
              style={{
                fontSize: "0.9rem",
                color: "#8B9BB4",
                textDecoration: "none",
              }}
            >
              {item.label}
            </Link>
          ))}
          <a
            href="https://support.wavetech.solutions/support"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: "0.9rem",
              color: "#8B9BB4",
              textDecoration: "none",
            }}
          >
            Support
          </a>
        </nav>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
          }}
        >
          <a
            href="https://www.linkedin.com/company/wavetech-solutions-99/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            style={{
              color: "#8B9BB4",
              fontSize: "1.25rem",
              textDecoration: "none",
            }}
          >
            LinkedIn
          </a>
          <a
            href="https://www.youtube.com/@WavetechSolutions88"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            style={{
              color: "#8B9BB4",
              fontSize: "1.25rem",
              textDecoration: "none",
            }}
          >
            YouTube
          </a>
        </div>
      </div>
    </motion.footer>
  );
}

export default Footer;